import React, { Component } from 'react';
import withWidth from 'material-ui/utils/withWidth';
import Welcome from './Welcome';

const styles = {
    welcome: { marginBottom: '2em' },
    flex: { display: 'flex' },
    leftCol: { flex: 1, marginRight: '1em' },
    rightCol: { flex: 1, marginLeft: '1em' },
    singleCol: { marginTop: '2em' },
};

class Dashboard extends Component {
    state = {};

    componentDidMount() {
    }

    render() {
        return (
            <div>
                <Welcome style={styles.welcome} />
            </div>
        );
    }
}

export default withWidth()(Dashboard);



// WEBPACK FOOTER //
// ./src/routes/dashboard/Dashboard.js